module.exports = __webpack_public_path__ + "img/spotify-web.504befa6.png";